export type NormalizedRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export type NormalizedPoint = {
  x: number;
  y: number;
};

export function normalizeRotationDegrees(value: number): number {
  const normalized = ((Math.round(value) % 360) + 360) % 360;
  return normalized === 90 || normalized === 180 || normalized === 270 ? normalized : 0;
}

export function rotateRectToDisplay(rect: NormalizedRect, rotationDegrees: number): NormalizedRect {
  const rotation = normalizeRotationDegrees(rotationDegrees);
  return clampRect(rotation === 90
    ? { x: 1 - rect.y - rect.height, y: rect.x, width: rect.height, height: rect.width }
    : rotation === 180
      ? { x: 1 - rect.x - rect.width, y: 1 - rect.y - rect.height, width: rect.width, height: rect.height }
      : rotation === 270
        ? { x: rect.y, y: 1 - rect.x - rect.width, width: rect.height, height: rect.width }
        : rect);
}

export function rotateRectToOriginal(rect: NormalizedRect, rotationDegrees: number): NormalizedRect {
  return rotateRectToDisplay(rect, normalizeRotationDegrees(360 - normalizeRotationDegrees(rotationDegrees)));
}

export function displayPointToOriginal(point: NormalizedPoint, rotationDegrees: number): NormalizedPoint {
  const rotation = normalizeRotationDegrees(rotationDegrees);
  const original = rotation === 90
    ? { x: point.y, y: 1 - point.x }
    : rotation === 180
      ? { x: 1 - point.x, y: 1 - point.y }
      : rotation === 270
        ? { x: 1 - point.y, y: point.x }
        : point;
  return {
    x: clampUnit(original.x),
    y: clampUnit(original.y),
  };
}

export function rotationStyle(rotationDegrees: number): string {
  const rotation = normalizeRotationDegrees(rotationDegrees);
  return rotation === 0 ? '' : `transform: rotate(${rotation}deg);`;
}

function clampRect(rect: NormalizedRect): NormalizedRect {
  const left = clampUnit(Math.min(rect.x, rect.x + rect.width));
  const top = clampUnit(Math.min(rect.y, rect.y + rect.height));
  const right = clampUnit(Math.max(rect.x, rect.x + rect.width));
  const bottom = clampUnit(Math.max(rect.y, rect.y + rect.height));
  return {
    x: left,
    y: top,
    width: Math.max(0, right - left),
    height: Math.max(0, bottom - top),
  };
}

function clampUnit(value: number): number {
  return Math.min(1, Math.max(0, value));
}
